import axios from 'axios'
import { ensureCsrfToken, isCsrfFailure } from './csrf'

/**
 * 合言葉が古いだけのときに、1回だけ取り直してやり直す。
 *
 * ## なぜ要るのか
 *
 * サーバを入れ替えるとセッションが消え、合言葉も消える。画面は古い値を
 * 送り続けて、**押しても何も起きない**状態になる。利用者には理由が
 * 分からないので、たいてい「壊れた」と言われて終わる。
 *
 * 取り直して1回だけやり直せば、たいていはそのまま通る。
 *
 * ## 1回だけにする
 *
 * 何度もやり直すと、本当に断られている操作を**繰り返し実行しようと
 * する**。同じ登録が2回入る事故になりうる。印を付けて、同じ要求では
 * 二度と繰り返さない。
 *
 * ## 印でだけ見分ける
 *
 * 403 なら何でもやり直す、にはしない。権限が無くて断られたものまで
 * やり直すことになる。サーバが付けた印（`CSRF_TOKEN_INVALID`）だけを見る。
 */

/** この要求は、もうやり直した。 */
const RETRIED = 'preikaCsrfRetried'

/**
 * 取り付ける。**アプリの起動時に1回だけ呼ぶ。**
 *
 * @returns 取り外す関数（検査で使う）
 */
export function installCsrfRetry () {
  const id = axios.interceptors.response.use(
    response => response,
    async error => {
      const config = error && error.config

      if (!config || config[RETRIED] || !isCsrfFailure(error)) {
        return Promise.reject(error)
      }

      config[RETRIED] = true

      const refreshed = await ensureCsrfToken()
      if (!refreshed) {
        return Promise.reject(error)
      }

      return axios.request(config)
    }
  )

  return () => axios.interceptors.response.eject(id)
}
